import { useCreateEmptyFolder } from '@/hooks/useCreateEmptyFolder';
import cuid from 'cuid';
import Balancer from 'react-wrap-balancer';
import { Button } from '../Button/Button';

export const SidebarEmptyPlaceholder = () => {
  const { createEmptyFolder } = useCreateEmptyFolder();
  return (
    <div className="w-full rounded-xl gap-3 bg-secondary flex items-center justify-between py-5 flex-col">
      <p className="text-muted-foreground font-semibold text-center w-full text-sm">
        <Balancer>
          Use folders to organize and chat with groups of files
        </Balancer>
      </p>
      <Button
        size="xs"
        className="h-7"
        onClick={() => createEmptyFolder({ id: cuid() })}
      >
        New folder
      </Button>
    </div>
  );
};
